import {Pipe, PipeTransform} from '@angular/core'

@Pipe({name: 'searchObject'})
export class SearchObjectPipe implements PipeTransform {
    transform (arr: any[], txt: string, fields: string[], minLen: number, all?: boolean): any {
        console.log('searchObject: arr.length:' + arr.length + ' / txt:' + txt + ' / all:' + JSON.stringify(all))
        if ((!arr)) return []
        if (!txt) return (!all) ? [] : arr
        if (!minLen) minLen = 1
        if (txt.length < minLen) return (!all) ? [] : arr

        console.log('searchObject proceed to filter')
        const res = arr.filter(item => {
            let found = false
            fields.forEach(field => {
                if (item[field]) {
                    let str = item[field].toLowerCase()
                    if (str.indexOf(txt.toLowerCase()) > -1) {
                        found = true
                        return
                    }
                }
            })
            return found
        })
        return res
    }
}
